export default __webpack_public_path__ + "static/media/logo_ma512.ef4b06e1.png";